const HandleInputChange = (e, setFormData) => {
  const { name, value, type, checked, files } = e.target;
  if (type === "checkbox") {
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  } else if (type === "file") {
    setFormData((prevState) => ({
      ...prevState,
      [name]: files[0],
    }));
  } else {
    setFormData((prevState) => ({
      ...prevState,
      [name]: name === "usdPrice" || name === "iraqiPrice" ? value.toString() : value,
    }));
  }
};

export default HandleInputChange;
